export default __webpack_public_path__ + "static/media/OnlineEntries.a6506221.png";